import { Box, Typography, Switch, SxProps } from "@mui/material";
import useIsMobile from "components/hooks/useIsMobile";

export default ({
  disabled = false,
  onChange,
  checked,
  label,
  helperText,
  sx,
  size = "medium",
}: {
  disabled?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checked: boolean | undefined;
  label: string;
  helperText?: string;
  size?: "small" | "medium";
  sx?: SxProps;
}) => {
  const isMobile = useIsMobile();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isMobile ? "row" : "row-reverse",
        alignItems: "center",
        justifyContent: isMobile ? "space-between" : "flex-end",
        gap: "16px",
        ...sx,
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Typography
          variant="body"
          color="text.primary"
          sx={{ fontWeight: 600 }}
        >
          {label}
        </Typography>
        {helperText && (
          <Typography variant="bodySmall" color="body">
            {helperText}
          </Typography>
        )}
      </Box>
      <Switch
        disabled={disabled}
        onChange={onChange}
        checked={checked}
        size={size}
      />
    </Box>
  );
};
